const SCALE_FACTOR = 1000;

// Function to convert value to slider position using cubic root scaling
export function valueToSliderPosition(value) {
  return Math.cbrt(value / SCALE_FACTOR);
}

// Function to convert slider position back to value using cubic power
export function sliderPositionToValue(position) {
  return SCALE_FACTOR * Math.pow(position, 3);
}